import { render, staticRenderFns } from "./SideBlock.vue?vue&type=template&id=3ea67404&"
import script from "./SideBlock.vue?vue&type=script&lang=js&"
export * from "./SideBlock.vue?vue&type=script&lang=js&"
import style0 from "./SideBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports